import { UAParser } from 'ua-parser-js'

/**
 * 获取当前操作系统信息
 */
export const getPlatformInfo = () => {
  const parser = new UAParser()
  const os = parser.getOS()
  
  return {
    name: os.name || 'Unknown',
    version: os.version || 'Unknown',
    isMac: os.name === 'macOS',
    isWindows: os.name === 'Windows',
    isLinux: os.name === 'Linux',
    isAndroid: os.name === 'Android',
    isIOS: os.name === 'iOS'
  }
}

/**
 * 获取适当的粘贴快捷键提示
 */
export const getPasteKeyHint = (): string => {
  const platform = getPlatformInfo()
  // console.log(platform)
  return platform.isMac || platform.isIOS ? 'Cmd+V' : 'Ctrl+V'
}

/**
 * 检查是否为Mac系统（包括iOS）
 */
export const isMacPlatform = (): boolean => {
  const platform = getPlatformInfo()
  return platform.isMac || platform.isIOS
}

/**
 * 检查是否为移动设备
 */
export const isMobileDevice = (): boolean => {
  const parser = new UAParser()
  const device = parser.getDevice()
  const os = parser.getOS()

  // 检查设备类型或操作系统
  return (
    device.type === 'mobile' ||
    device.type === 'tablet' ||
    os.name === 'Android' ||
    os.name === 'iOS' ||
    window.innerWidth <= 768
  )
}